import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export interface IProductDetailsHistoryService {
  clientId: string
  productId: string
}

export const productDetailsHistoryService = async ({
  clientId,
  productId,
}: IProductDetailsHistoryService) => {
  const { data } = await api.get<ResponseAPI>(
    `historico/${clientId}/${productId}`,
  )

  return data
}
